import {
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '../ui/dialog';

interface Shortcut {
  keys: string[];
  description: string;
}

const shortcuts: Shortcut[] = [
  { keys: ['⌘', 'K'],         description: 'Open search' },
  { keys: ['⌘', '/'],         description: 'Toggle sidebar' },
  { keys: ['G', 'D'],         description: 'Go to Dashboard' },
  { keys: ['G', 'C'],         description: 'Go to Campaigns' },
  { keys: ['G', 'A'],         description: 'Go to Automations' },
  { keys: ['G', 'S'],         description: 'Go to Segments' },
  { keys: ['N', 'C'],         description: 'New Campaign' },
  { keys: ['N', 'A'],         description: 'New Automation' },
  { keys: ['?'],              description: 'Show this dialog' },
  { keys: ['Esc'],            description: 'Close modal / panel' },
];

interface KeyboardShortcutsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function KeyboardShortcutsModal({ open, onOpenChange }: KeyboardShortcutsModalProps) {
  return (
    <DialogRoot open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-2 mt-2">
          {shortcuts.map((shortcut, i) => (
            <div
              key={i}
              className="flex items-center justify-between gap-3 rounded-lg bg-bg-subtle px-3 py-2.5"
            >
              <span className="text-sm text-text-secondary">{shortcut.description}</span>
              <span className="flex shrink-0 items-center gap-1">
                {shortcut.keys.map((key, j) => (
                  <kbd
                    key={j}
                    className="inline-flex h-6 min-w-[24px] items-center justify-center rounded border border-border-subtle bg-surface-card px-1.5 font-mono text-xs text-text-primary"
                  >
                    {key}
                  </kbd>
                ))}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-4 text-xs text-text-tertiary">
          On Windows / Linux, replace ⌘ with Ctrl.
        </p>

        <DialogClose className="absolute right-4 top-4 rounded-md p-1 text-text-tertiary hover:bg-bg-subtle transition-colors" />
      </DialogContent>
    </DialogRoot>
  );
}
